import { Mic, MicOff } from 'lucide-react'
import { Button } from '../ui/button'
import { cn } from '../ui/utils'

export type VoiceButtonState = 'idle' | 'listening' | 'processing' | 'speaking'

interface VoiceButtonProps {
  state: VoiceButtonState
  onClick: () => void
  disabled?: boolean
  className?: string
}

export function VoiceButton({ state, onClick, disabled, className }: VoiceButtonProps) {
  const isActive = state === 'listening' || state === 'processing'
  
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      size="lg"
      className={cn(
        "rounded-full w-16 h-16 p-0 transition-all duration-300",
        state === 'idle' && "bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600",
        state === 'listening' && "bg-red-500 hover:bg-red-600 animate-pulse",
        state === 'processing' && "bg-yellow-500 hover:bg-yellow-600",
        state === 'speaking' && "bg-green-500 hover:bg-green-600",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      aria-label={
        state === 'idle' ? 'Start listening' :
        state === 'listening' ? 'Stop listening' :
        state === 'processing' ? 'Processing' :
        'AI is speaking'
      }
    >
      {state === 'listening' || state === 'processing' ? (
        <MicOff className="w-6 h-6" />
      ) : (
        <Mic className="w-6 h-6" />
      )}
    </Button>
  )
}


